export const SIDEBAR_WIDTH = {
  expanded: 264,
  collapsed: 64,
} as const;

export const CHAT_PANEL = {
  width: 380,
  widthPx: '380px',
} as const;

export const PLAN_LIMITS: Record<string, number> = {
  'Free': 100,
  'Starter': 500,
  'Pro': 2000,
  'Enterprise': 10000,
};
